import React from "react";
import ProcurementForm from "../components/forms/ProcurementForm";

const Procurement: React.FC = () => {
  return (
   <>
   <ProcurementForm />
   </>
  );
};

export default Procurement;
